import { useEffect } from "react";
import { Link } from "react-router-dom";
import { track } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";
import { useBooking } from "@/context/BookingContext";
import SEO from "@/components/SEO";
import { UtensilsCrossed, CalendarCheck, CalendarDays, Star, Instagram, Navigation } from "lucide-react";

export default function LinkLanding() {
  const { settings } = useSettings();
  const { open: openBooking } = useBooking();
  useEffect(() => { track("page_view", "landing"); }, []);

  const Item = ({ icon: Icon, label, onClick, to, href, testid }) => {
    const inner = (
      <div className="flex items-center gap-4 bg-white/95 rounded-xl px-5 py-4 border border-brass/25 hover:border-brass hover:shadow-md transition-all active:scale-[0.98]">
        <Icon className="w-5 h-5 text-bordeaux" />
        <span className="font-serif text-lg text-oak">{label}</span>
      </div>
    );
    if (to) return <Link to={to} data-testid={testid}>{inner}</Link>;
    if (href) return <a href={href} target="_blank" rel="noreferrer" onClick={onClick} data-testid={testid}>{inner}</a>;
    return <button onClick={onClick} data-testid={testid} className="w-full text-left">{inner}</button>;
  };

  return (
    <div className="min-h-screen bg-oak-dark py-12 px-5">
      <SEO title="Benvenuti" />
      <div className="max-w-md mx-auto text-center">
        <p className="font-accent italic text-brass text-lg">Dal 1961 a Zola Predosa</p>
        <h1 className="font-serif text-4xl text-cream mb-1">Ristorante Masetti</h1>
        <p className="font-accent italic text-cream/70 mb-8">“La cucina bolognese, per stare insieme.”</p>
        <div className="space-y-3">
          <Item icon={UtensilsCrossed} label="Il Menù" to="/menu" testid="landing-menu" />
          <Item icon={CalendarCheck} label="Prenota un tavolo" onClick={() => openBooking("landing")} testid="landing-prenota" />
          <Item icon={CalendarDays} label="Eventi" to="/eventi" testid="landing-eventi" />
          <Item icon={Star} label="Lascia una recensione" to="/recensione" testid="landing-recensione" />
          {settings.instagram_url && <Item icon={Instagram} label="Seguici su Instagram" href={settings.instagram_url} onClick={() => track("instagram_click", "landing")} testid="landing-instagram" />}
          {settings.google_maps_url && <Item icon={Navigation} label="Indicazioni stradali" href={settings.google_maps_url} onClick={() => track("maps_click", "landing")} testid="landing-maps" />}
        </div>
      </div>
    </div>
  );
}
